import { runningClientSide } from '@benzinga/utils';
import { isMobile } from '@benzinga/device-utils';

export const DEFAULT_PRIMIS_ID = '108449';
export const DEFAULT_MOBILE_PRIMIS_ID = '110299';
export const DEFAULT_AMP_PRIMIS_ID = '109503';

/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum BzChannelsPrimisIds {
  'cannabis' = '108519',
  'mining' = '109965',
  'energy' = '109965',
  'nft' = '109966',
  'crypto' = '109967',
  'cryptocurrency' = '109967',
  'fintech' = '109968',
  'biotech' = '109969',
}

export enum BzChannelsMobilePrimisIds {
  'cannabis' = '110300',
  'mining' = '110305',
  'energy' = '110305',
  'nft' = '110448',
  'crypto' = '110306',
  'cryptocurrency' = '110306',
  'fintech' = '110307',
  'biotech' = '110308',
}

export enum BzChannelsAMPPrimisIds {
  'cannabis' = '109977',
  'mining' = '109982',
  'energy' = '109982',
  'nft' = '109981',
  'crypto' = '109980',
  'cryptocurrency' = '109980',
  'fintech' = '109979',
  'biotech' = '109976',
}
/* eslint-enable @typescript-eslint/no-duplicate-enum-values */

export const getPrimisIDbyChannel = (channelsSlugs: string[], amp = false): string => {
  let primisID = null;

  if (Array.isArray(channelsSlugs)) {
    for (const slug of channelsSlugs) {
      const channelName = slug?.toLowerCase();

      if (amp && !!BzChannelsAMPPrimisIds[channelName]) {
        primisID = BzChannelsAMPPrimisIds[channelName];
        break;
      } else if (isMobile() && !!BzChannelsMobilePrimisIds[channelName]) {
        primisID = BzChannelsMobilePrimisIds[channelName];
        break;
      } else if (BzChannelsPrimisIds[channelName]) {
        primisID = BzChannelsPrimisIds[channelName];
        break;
      }
    }
  }

  if (amp) {
    return primisID || DEFAULT_AMP_PRIMIS_ID;
  }

  if (isMobile()) {
    return primisID || DEFAULT_MOBILE_PRIMIS_ID;
  }

  return primisID || DEFAULT_PRIMIS_ID;
};

export const getAMPPrimisIDbyChannel = (channelsSlugs: string[]): string => {
  return getPrimisIDbyChannel(channelsSlugs, true);
};

export const PrimisURL = (id = '108449'): string => {
  const currentDate = new Date();
  const timestamp = currentDate.getTime();

  let src = `https://live.primis.tech/live/liveView.php?s=${id}&cbuster=${timestamp}`;
  if (id === '108026' || id === '111717') {
    src += '&vp_content=https://cdn3.wowza.com/1/QnB4OTF2emdYY3o3/MkcvZ09x/hls/live/playlist.m3u8';
  }
  return src;
};

export const LoadPrimisVideoPlayer = (id = '108449', selector: string, src: string) => {
  if (!runningClientSide()) {
    return;
  }

  if (document.getElementById('primis-video')) {
    return;
  }

  (function (d, s, n) {
    const placeholder = document.querySelector(selector || `#primis-${id}`);

    if (placeholder) {
      const js = d.createElement(s) as HTMLScriptElement;
      js.id = n;
      js.src = src;
      js.defer = true;
      placeholder.appendChild(js);
    }
  })(document, 'script', 'primis-video');
};

export interface PrimisProps {
  id?: string;
  selector?: string;
  renderPlaceholder?: boolean;
  placeholderId?: string;
  renderOnEvent?: boolean;
}

const RENDER_PRIMIS = 'render-primis-video';

export const renderPrimisVideo = () => {
  if (runningClientSide()) {
    window.dispatchEvent(new Event(RENDER_PRIMIS));
  }
};
